import responseToJson from "./http/responseToJson";
import checkResponseStatus from "./http/checkResponseStatus";

class HttpIntegration {
  async read({ url, method, headers, credentials, body }) {
    const response = await fetch(url, {
      method,
      headers,
      credentials,
      body: JSON.stringify(body)
    });

    return responseToJson(checkResponseStatus(response));
  }
}

export default HttpIntegration;
